/* eslint-disable no-use-before-define */
import { Component, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-cdb-datepicker',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.css'],
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: CdbDatepickerComponent, multi: true }
  ]
})
export class CdbDatepickerComponent implements ControlValueAccessor {
  @Input() value: Date;

  disabled = false;

  onChange = (_: any) => { };
  onTouch = (_: any) => { };

  writeValue(value: Date): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState(disabled: boolean): void {
    this.disabled = disabled;
  }

  onDateChange($event: any) {
    this.onChange(this.formatValue(new Date($event.value)));
    this.onTouch($event);
  }

  private formatValue(dt: Date): any {
    if (dt) {
      const month = `00${dt.getMonth() + 1}`.slice(-2);
      const date = `00${dt.getDate()}`.slice(-2);
      const year: number = dt.getFullYear();
      let newDate: string;

      if (year >= 20 && year <= 30) {
        newDate = `${year}00-${month}-${date}T00:00:00`;
      }
      else {
        newDate = `0000${year}`.slice(-4) + `-${month}-${date}T00:00:00`;
      }

      return newDate === '1969-12-31T00:00:00' ? null : newDate;
    }
    else {
      return null;
    }
  }
}
